import React, { useRef } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import JobCard from './JobCard';
import { JobResult } from '../types/job';

interface JobCardListProps {
  results: JobResult[];
}

const JobCardList: React.FC<JobCardListProps> = ({ results }) => {
  const container = useRef<HTMLDivElement>(null);

  useGSAP(() => {
    const prefersReduced = typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Skip the entrance entirely for reduced-motion users — cards render at rest.
    if (prefersReduced) return;

    gsap.from('.job-card', {
      duration: 0.4,
      y: 20,
      opacity: 0,
      delay: 0.1,
      stagger: 0.05,
      ease: 'power2.out',
      // Strip the inline transform GSAP leaves behind, so the CSS hover lift wins.
      clearProps: 'all',
    });
  }, { scope: container, dependencies: [results] });

  return (
    <div ref={container} className="job-card-list">
      {results.map((result, index) => (
        <JobCard key={index} result={result} />
      ))}
    </div>
  );
};

export default JobCardList;
